export const employeeStatus = {
  active: 'AC',
  unactive: 'SU',
  unlinked: 'DV',
  in_process: 'EP',
}
